import { ActionTree } from 'vuex';
import { setupApollo } from '@/lib/apollo_setup';
import { FETCH_TOTAL_RECEIVED_APPLICATIONS } from '@/graphql/applications/queries';
import { NavigationState } from './types';

const apolloProvider = setupApollo();

const actions: ActionTree<NavigationState, any> = {
  async initializeNavigation({ dispatch }) {
    await dispatch('fetchNavigationData');
  },

  async fetchNavigationData({ commit }) {
    try {
      const badgeResult = await apolloProvider.defaultClient.query({
        query: FETCH_TOTAL_RECEIVED_APPLICATIONS,
        fetchPolicy: 'network-only',
      });

      const receivedAppsCount = badgeResult?.data?.viewer?.totalReceivedApplications || 0;

      commit('setReceivedAppsCount', receivedAppsCount);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('GraphQL query error:', error);
    }
  },
};

export default actions;
